module.exports = ".flight-details-container .row .col-6:first-child {\n    border-right: 1px solid black;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/flights/details/flight-details.component.css
// module id = ./src/app/flights/details/flight-details.component.css
// module chunks = main